import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Grid,
  LinearProgress
} from '@mui/material';
import Box from 'component/layoutComponents/Box';
import Typography from 'component/MarketPlace/Typography';
import React, { Fragment } from 'react';
import VideoDialog from './Dialog';
import { ArrowForwardIos, CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
// import { MarketplaceThemeProvider } from "../../theme/MarketplaceTheme";
import { ImageWrapper, StyledAvatar } from './index.style';
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from "../../theme/defaultTheme";
import CEOIMG from '../../../assets/images/onBoarding/ceo.png';
import DEVICEIMG from '../../../assets/images/onBoarding/device.png';
import { StyledIcon } from "component/commonComponents/Icon/icon.style";

type TaskStatus = 'pending' | 'completed';

type NewJoinerTask = {
  id?: string;
  joiner_id?: string;
  task_definition_id: string;
  status: TaskStatus;
  completed?: string;
  name?: string;
  description?: string;
  url?: string;
  file_type?: string;
  img?: string;
  active?: boolean;
  picture?: string;
};

export interface IActivityAssign {
  orderTaskDefinitionId: any
  checkLocation: any,
  listNewJoinerTask: any,
  videoUrl: any,
  isOpen: boolean,
  locale: any,
  handleToggleCompleted: ({task}: {task: NewJoinerTask}) => void,
  handleClose: () => void,
  handleButtonClick: ({file_type, url}: NewJoinerTask) => void,
}
const STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
};

const ActivityAssign = (props: IActivityAssign) => {
  const { orderTaskDefinitionId, checkLocation, listNewJoinerTask, videoUrl, isOpen, locale, handleToggleCompleted, handleClose, handleButtonClick } = props;

  const getRandomValueFromArray = (array: any) => {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
  };

  const theme = useTheme() as typeof DefaultUptimeTheme;

  const doneList = listNewJoinerTask.data.filter((item: any) => item.status === STATUS.COMPLETED);

  const total = listNewJoinerTask.totalCount;
  const progress = doneList.length / total;

  return (
    <>
      {checkLocation  ? (
      <>
      <Card sx={{borderRadius:"4px", boxShadow: `0px 0px 0px 1px ${theme.uptimeColors.grayScales.boxShadow}`, minHeight:"413px"}}>
        <CardHeader
          title={locale?.header}
          titleTypographyProps={{variant:'h6'}}
          action={
            <Box paddingRight="16px">
              <Typography color='primary.main' sx={{marginBottom: '4px'}} variant="body2">
                {doneList.length}/{total} {locale?.completed}
              </Typography>
              <LinearProgress variant="determinate" value={progress * 100} sx={{borderRadius:'24px'}} />
            </Box>
          }
          sx={{paddingBottom:"0px"}}
        />
        <Divider sx={{ mt: 1 }}/>
        <CardContent
          sx={{ maxHeight: '361px', overflow: 'auto', padding: '0 16px 0 16px !important' }}
        >
          {listNewJoinerTask.data.length > 0 ? (
            listNewJoinerTask.data.map((task: any, index: any) => (
              <Fragment key={task.id}>
                <Grid container padding='12px 0 14px 0'>
                <Grid
                    item
                    xs='auto'
                    display='flex'
                    alignItems='center'
                    marginRight='20px'
                  >
                    <ImageWrapper>
                      <StyledAvatar src={task?.picture ? task?.picture : getRandomValueFromArray([CEOIMG,DEVICEIMG])} alt={task.name}/>
                    </ImageWrapper>
                  </Grid>
                  <Grid item xs>
                    <Box 
                      display='flex'
                      flexDirection='column'
                      height='92px'
                      justifyContent=' space-between'
                      alignItems='flex-start'
                    >
                      <Typography variant="h6">
                        {task.name}
                      </Typography>
                      {task.description && (
                      <Typography paddingBottom="16px" variant="subtitle2">
                        {task.description}
                      </Typography>
                      )}
                      <Button
                      variant='contained'
                      size='small'
                      disabled={task.task_definition_id === orderTaskDefinitionId && task.status === STATUS.COMPLETED}
                      endIcon={
                        <StyledIcon
                          styleIcon={{
                            fontSize: (theme.uptimeFontSizes.desktop.fz2 as unknown) as string,
                        }}>
                          <ArrowForwardIos />
                        </StyledIcon>}
                      onClick={() => handleButtonClick(task)}
                      sx={{ fontSize: '12px', minHeight: '24px !important', height: '24px'}}
                                          >
                      {task.file_type === 'video'
                        ? locale?.watchvideo
                        : locale?.clickhere}
                      </Button>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs="auto"
                    display='flex'
                    alignItems='center'
                  >
                    <Checkbox
                      icon={<RadioButtonUnchecked />}
                      checkedIcon={<CheckCircle />}
                      checked={task.status === STATUS.COMPLETED}
                      onChange={() => handleToggleCompleted(task)}
                      sx={{'&.Mui-checked': {
                        color: task.task_definition_id !== orderTaskDefinitionId ? theme.uptimeColors.generalColors.state.success.light : '',
                      }}}
                      disabled={task.task_definition_id === orderTaskDefinitionId}
                    ></Checkbox>
                  </Grid>
                </Grid>
                <Divider />
              </Fragment>
            ))
          ) : (
            <>{locale?.noTasks}</>
          )}
        </CardContent>
      </Card>
      <VideoDialog
        src={videoUrl}
        isOpen={isOpen}
        title=""
        handleClose={handleClose}
      />
      </>) : (<></>)}
    </>
  );
};

ActivityAssign.defaultProps = {
  listNewJoinerTask: {
    data: [],
    totalCount: 0,
  },
};

export default ActivityAssign;
